import React from 'react'
import { Navigate } from 'react-router-dom'
import { usePermissions, type PermissionAction } from '../../hooks/usePermissions'
import type { AppModule } from '../../types/company_member.types'

interface CanProps {
  module: AppModule
  action: PermissionAction
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function Can({ module, action, children, fallback = null }: CanProps) {
  const { can } = usePermissions()

  if (can(module, action)) {
    return <>{children}</>
  }

  return <>{fallback}</>
}

export function RequirePermission({ module, action, children }: Omit<CanProps, 'fallback'>) {
  const { can } = usePermissions()

  if (can(module, action)) {
    return <>{children}</>
  }

  // Se não tem acesso ao dashboard em si, exibe uma mensagem para evitar loop de redirecionamento
  if (module === 'dashboard') {
    return (
      <div style={{ 
        display: 'flex', flexDirection: 'column', alignItems: 'center', 
        justifyContent: 'center', height: '100%', padding: '3rem', 
        textAlign: 'center', color: 'var(--text-2)' 
      }}>
        <svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" style={{ marginBottom: '1rem', color: 'var(--warning)' }}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <h2 style={{ color: 'var(--text-1)', marginBottom: '0.5rem' }}>Acesso Restrito</h2>
        <p>Você não possui permissões para visualizar o dashboard inicial.</p>
        <p style={{ fontSize: '0.9rem' }}>Selecione uma opção no menu lateral para navegar ou contate o administrador.</p>
      </div>
    )
  }

  // Se for qualquer outra rota, redireciona para o dashboard
  return <Navigate to="/dashboard" replace />
}
